function SubAbasUser(fichaID: string): { label: string; rota: string }[] {
  return [
    {
      label: 'Usuários',
      rota: `/secsaude/adm/usuarios/ficha/${fichaID}/dadosgerais`,
    },
  ];
}

export default SubAbasUser;
